// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__35y_v","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3QRhV","obliqueLine":"membershipbadge_obliqueLine__26ks8"};